import { analyticEvents } from "@actions/analyticEvents";
import { fetchConfig } from "@service/apiServices";
import {
  fetchConfigStart,
  fetchConfigSuccess,
  fetchConfigFailure,
  updateNormalisedConfig,
  updateLottieAnimationLoopCompleted
} from "@store/slices/config";
import {
  resetState,
  setData,
  setFieldErrorData,
  setToastData
} from "@store/slices/globalState";
import {
  allLottieAnimationComplete,
  skipLottieAnimation,
  updateIsMmvDataFound,
  updateLottieAnimationKey,
  updateNextNodeSuccess,
  updateNextNodeUpcoming,
  updateRedirectionDone
} from "@store/slices/lottieState";
import { updateLottieAnimationLoopCompletedd } from "@store/slices/lottieState";
import { store } from "@store/store";
import {
  checkIfErrorNode,
  checkIfRenewalJourney,
  ENTER_MMV_DETAILS_NODE,
  getRequestpayload,
  REVIEW_EDIT_NODE,
  scrollIntoViewWrapper
} from "@utils/index";
import QUERY_PRESERVE_PARAMS, { getUtmQueryParams } from "@utils/utm";
import Router from "next/router";
import { isEmpty } from "@utils/lodash";
import { updatePropsAction } from "@actions/updateProps";
import { getPersistedPayloadFromStorage } from "@actions/persistPayloadToStorage";
import { OWNERSHIP_TRANSFER_OPTIONS_NODE } from "@utils/constants";

export const fetchConfigAndRedirect = async ({
  shouldRedirect = false,
  shouldClearStore = false,
  showBasicLoader = true,
  showLottie = false,
  lottieAnimationKey = "",
  nextLottieAnimationKey = "",
  isRouterReplace = false,
  showInitialLottieFull = false,
  nextCustomAnimationText = "",
  hideCommercialField = false,
  requestHeaders = {},
  ...payload
}) => {
  const { proposal_ekey, current_node, plan_name, registration_number, booking_status } = Router.query;
  const utmParams = getUtmQueryParams(Router.query);
  const registrationNumberParam = Array.isArray(registration_number) ? registration_number[0] : registration_number;
  /*
  showCustomBasicLoader: true, for which basic loader is enalbed via config :) ,
  showCustomLottie: false for which lottie is diabled :) 
  */
  const {
    customAnimationText = "",
    showCustomBasicLoader = true,
    showCustomLottie = true
  } = payload;
  if (shouldClearStore) {
    // for handling cases where user goes back to registration_number and starts new journey
    store?.dispatch(resetState());
  }
  const state = store?.getState();

  let requestBody = { ...payload.requestBody };

  let requestPayload = state.globalState.requestPayload;
  const data = state.globalState.payloadData;

  // custom logic for sending to error node (in commercial Cases)
  if (current_node === ENTER_MMV_DETAILS_NODE && data?.is_commercial) {
    requestBody = {
      ...requestBody,
      expected_node: "error_node"
    };
  }

  if (isEmpty(requestPayload)) {
    requestPayload = getRequestpayload();
  }

  let payloadData = {
    ...requestPayload,
    ...requestBody,
    ...(!!current_node && { current_node: current_node }),
    data: {
      ...requestPayload.data,
      ...data,
      ...(booking_status && { booking_status: booking_status }),
      ...payload.data,
      ...requestBody.data,
      ...(proposal_ekey && { proposal_ekey: proposal_ekey }),
      ...utmParams,
      ...(plan_name && { plan_name: plan_name })
    }
  };
  if (
    current_node === OWNERSHIP_TRANSFER_OPTIONS_NODE && registrationNumberParam && !payloadData?.data?.registration_number
  ) { 
    payloadData.data = { ...payloadData.data, registration_number: registrationNumberParam};
  }
  try {
    if (requestPayload?.journey === "dashcam" && (current_node === "checkout_review_node" || current_node === "slot_selection_node")) {
      const persistedAddress = getPersistedPayloadFromStorage({ key: "dashcam_address_payload" });
      const persistedSlots = getPersistedPayloadFromStorage({ key: "slot_selection_payload" });
      if (persistedAddress && typeof persistedAddress === "object") {
        payloadData = {
          ...payloadData,
          data: {
            ...payloadData.data,
            ...persistedAddress,
            ...persistedSlots
          }
        };
      } else {
        payloadData = {
          ...payloadData,
          expected_node: "select_car_address_node"
        };
      }
    }
  } catch (e) {
    // non-blocking
  }

  const isEditMadeOnReviewMMV = state?.configuration?.shouldRedirectToPlansNode;
  const prevUrlNode = state?.configuration?.config?.current_node;

  if (current_node === REVIEW_EDIT_NODE && prevUrlNode) {
    const phoneFromSessionStorage = sessionStorage?.getItem(
      "review_edit_node_phone_number"
    );
    const pincodeFromSessionStorage = sessionStorage?.getItem(
      "review_edit_node_pincode"
    );

    let isPhoneChanged = false;
    let isPincodeChanged = false;

    if (phoneFromSessionStorage && pincodeFromSessionStorage) {
      isPhoneChanged = phoneFromSessionStorage !== payloadData?.data?.phone;
      isPincodeChanged =
        Number(pincodeFromSessionStorage || "0") !== payloadData?.data?.pincode;
    }
    console.log("state:", state);

    // redirect user to plans_node
    if (isPhoneChanged || isPincodeChanged || isEditMadeOnReviewMMV) {
      console.log("payloadData:", { payloadData, prevUrlNode });
      // Keeping this logic on the BFF
      // payloadData.expected_node = "plan_selection_node";
      payloadData.expected_node = "";
    } else {
      // remove reg year and month from paylaod to make proposal stay in payment_ready state
      const { registration_year, registration_month, ...filteredData } =
        payloadData.data;
      payloadData.data = filteredData;
      console.log("as", payloadData);
    }
  }

  store?.dispatch(
    fetchConfigStart({
      // todo: reformat below condition
      showBasicLoader: showCustomBasicLoader && true,
      showLottie: showCustomLottie && true,
      lottieAnimationKey: lottieAnimationKey || "LOADER_ANIMATION",
      customAnimationText
    })
  );

  store?.dispatch(
    updateLottieAnimationKey({
      showLottie: showCustomLottie && true,
      lottieAnimationKey: lottieAnimationKey || "LOADER_ANIMATION",
      nextLottieAnimationKey: nextLottieAnimationKey || "",
      customAnimationText,
      showInitialLottieFull,
      nextCustomAnimationText: nextCustomAnimationText,
      nextNodeSuccess: false
    })
  );

  store?.dispatch(updateNextNodeSuccess({ nextNodeSuccess: false }));

  // for basic loader dont use the lottie animation completed once logic
  if (showCustomBasicLoader) {
    console.log(showCustomLottie);
    store?.dispatch(
      updateLottieAnimationLoopCompleted({
        lottieAnimationLoopCompleted: true
      })
    );
    !showCustomLottie &&
      store?.dispatch(
        updateLottieAnimationLoopCompletedd({
          lottieAnimationLoopCompleted: true
        })
      );
    !showCustomLottie &&
      store?.dispatch(
        skipLottieAnimation({
          showLottie: false
        })
      );
  }

  console.log(store?.getState());

  const startHandler = () => {
    console.log("Router change started");
  };

  const completeHandler = () => {
    store?.dispatch(updateRedirectionDone({ redirectionDone: true }));
    store?.dispatch(skipLottieAnimation({ showLottie: false }));
    if (window?.wisepops) {
      window?.wisepops("pageview");
    }
  };
  try {
    const data: any = await fetchConfig(payloadData, requestHeaders);
    const pollingInterval = 200;
    let intervalCount = 0;
    const MAX_INTERVAL_COUNT = 50;
    // let configSuccessDispatchedOnce = prevUrlNode === current_node
    if (shouldRedirect || current_node !== prevUrlNode) {
      store?.dispatch(resetState());
    }

    // For new_car journey AND entry_node, immediately mark lottie as completed when API returns successfully
    // to avoid waiting for lottie animation cycle completion
    const isNewCarJourney = requestBody?.journey === "new_car" || payloadData?.journey === "new_car";
    const isEntryNode = current_node === "entry_node" || requestBody?.current_node === "entry_node";
    // Only apply immediate completion for new_car journey + entry_node to avoid affecting other flows
    if (data && isNewCarJourney && isEntryNode) {
      store?.dispatch(
        updateLottieAnimationLoopCompletedd({
          lottieAnimationLoopCompleted: true
        })
      );
    }

    let redirectionIntervalId = setInterval(() => {
      let isLottieCycleCompleted =
        store?.getState()?.lottieState?.lottieAnimationLoopCompleted;
      let isLottieAnimationComplted =
        store?.getState()?.lottieState?.showLottie;
      const LottieDATA = store?.getState()?.lottieState;

      if (current_node !== prevUrlNode && current_node !== "entry_node") {
        store?.dispatch(skipLottieAnimation({ showLottie: false }));
      }
      // to handle hard-reload scenarios
      // remove loader once api is resolved
      if (data && LottieDATA?.showLottie === false) {
        store?.dispatch(
          updateLottieAnimationLoopCompletedd({
            lottieAnimationLoopCompleted: true
          })
        );
      }
      // For new_car journey AND entry_node, immediately mark lottie as completed when API returns successfully
      // to avoid waiting for lottie animation cycle completion
      const isNewCarJourney = requestBody?.journey === "new_car" || payloadData?.journey === "new_car";
      const isEntryNode = current_node === "entry_node" || requestBody?.current_node === "entry_node";
      // Only apply immediate completion for new_car journey + entry_node to avoid affecting other flows
      if (data && isNewCarJourney && isEntryNode) {
        store?.dispatch(
          updateLottieAnimationLoopCompletedd({
            lottieAnimationLoopCompleted: true
          })
        );
        // Re-read the state immediately after updating
        isLottieCycleCompleted = true;
      }
      if (data) {
        // TODO: REMOVE THIS DEPS FROM ACTIONS, MOVE TO RESOLVED DATA ITEM <--
        const isMmvDataFound = data?.actions?.on_load?.filter(
          (act) => act?.type === "dispatchCallEvents"
        )?.[0]?.args?.edata?.variant_id;

        // to check what animation we want to show in cng node
        if (isMmvDataFound) {
          store?.dispatch(
            updateIsMmvDataFound({
              isMmvDataFound: isMmvDataFound
            })
          );
        }
        store?.dispatch(
          updateNextNodeUpcoming({
            nextNodeUpcoming: data?.current_node
          })
        );
        // console.log("lolami2dumb", {
        //   COND: isLottieCycleCompleted,
        //   data,
        //   isMmvDataFound: isLottieCycleCompleted && data,
        //   ndcond: intervalCount === MAX_INTERVAL_COUNT,
        //   lastcond: current_node !== prevUrlNode && prevUrlNode
        // });
        store?.dispatch(updateNextNodeSuccess({ nextNodeSuccess: true }));
        if (checkIfErrorNode(data)) {
          store?.dispatch(
            updateLottieAnimationLoopCompletedd({
              lottieAnimationLoopCompleted: true
            })
          );
        }
      }

      if (
        (isLottieCycleCompleted && data) ||
        intervalCount === MAX_INTERVAL_COUNT ||
        (current_node !== prevUrlNode && prevUrlNode) ||
        (current_node === "entry_node" && checkIfRenewalJourney())
      ) {
        clearInterval(redirectionIntervalId);
        store?.dispatch(fetchConfigSuccess(data));
      }
      // TODO: RMOVE THIS (current_node !== prevUrlNode) added for backbtn scenarios
      if (
        (data && (shouldRedirect || current_node !== prevUrlNode)) ||
        intervalCount === MAX_INTERVAL_COUNT
      ) {
        const nextRedirect: any = isRouterReplace ? "replace" : "push";
        //es-lint-disabled-next-line no-undef
        // TODO: REMOVE THIS HACKY SOLUTION
        //! REMOVE DEPS FROM isLottieCycleCompleted WHEN ROUTING

        if (
          // !isLottieAnimationComplted ||
          isLottieCycleCompleted ||
          intervalCount === MAX_INTERVAL_COUNT ||
          (current_node === "entry_node" && checkIfRenewalJourney())
        ) {
          store?.dispatch(
            setData({
              hideCommercialField: hideCommercialField
            })
          );

          const urlParams = new URLSearchParams(window.location.search);
          const utmParams = {};
          const pathUrl = new URL(`http://dummydomain.com`);

          QUERY_PRESERVE_PARAMS.forEach((item) => {
            const value = urlParams.get(item);
            if (value && pathUrl.searchParams.get(item) !== value) {
              pathUrl.searchParams.append(item, value);
              utmParams[item] = value;
            }
          });

          const queryParams = {
            current_node: data?.current_node,
            ...(data?.url?.query_params?.plan_name && {
              plan_name: data?.url?.query_params?.plan_name
            }),
            ...(payloadData?.data?.booking_status && {
              booking_status: payloadData.data.booking_status
            }),
            ...utmParams
          };

          if (data?.url?.query_params?.ekey) {
            queryParams.proposal_ekey = data?.url?.query_params?.ekey;
          }
          if (data?.url?.query_params?.order_id) {
            queryParams.order_id = data?.url?.query_params?.order_id;
          }
          if (data?.url?.query_params?.hide_app_bar != null) {
            queryParams.hide_app_bar = String(
              data.url.query_params.hide_app_bar
            );
          }

          if (checkIfRenewalJourney() && !queryParams.hide_app_bar) {
            queryParams.hide_app_bar = "true";
          }
          Router?.[nextRedirect]({
            pathname: `/gi/auto-storefront/${data?.url?.base_path || "fresh-car"}`,
            query: queryParams
          }).then(() => {
            console.log("redirecting to new url :(", window.location.href);
          });
          Router.events.on("routeChangeStart", startHandler);
          Router.events.on("routeChangeComplete", completeHandler);
          // store?.dispatch(updateRedirectionDone({ redirectionDone: true }));
          // store?.dispatch(skipLottieAnimation({ showLottie: false }));
        }
      }
      ++intervalCount;
    }, pollingInterval);
  } catch (error: any) {
    const { response } = error;
    const errorDetails = response?.data?.data?.error_details;
    const { method, message, component } = errorDetails || {};
    const code = response?.data?.data?.code || {};
    const journey = requestPayload?.journey || {};
    if (errorDetails) {
      if (method === "toast") {
        store?.dispatch(
          setToastData({
            toastMessage: "Something went wrong",
            toastMessageType: "error"
          })
        );
      } else if (method === "field_error") {
        if (
          (journey === "renewal_car" || journey === "renewal_bike") &&
          code === "UNSERVICEABLE_PINCODE"
        ) {
          updatePropsAction({
            component_id: "unserviceable-pincode-modal",
            update_props: { is_visible: true }
          });
        } else {
          store?.dispatch(
            setFieldErrorData({
              message: message,
              componentName: component,
              show: true
            })
          );
        }
      }
    }

    analyticEvents({
      edata: {
        product: "car",
        exception_type: "next_node_api_failure",
        action_type: "api_failed",
        method: method,
        error_message: JSON.stringify(message)
      },
      odata: {
        journey: "fresh_car"
      },
      event_name: "exception"
    });

    store?.dispatch(fetchConfigFailure(error?.message));
    store?.dispatch(allLottieAnimationComplete({}));
    store?.dispatch(
      skipLottieAnimation({
        showLottie: false
      })
    );
  }
};

export const validateAndFetchConfigAndRedirect = async ({
  shouldRedirect = false,
  onlyValidate = false,
  showBasicLoader = true,
  showLottie = false,
  lottieAnimationKey = "",
  showCustomBasicLoader,
  showCustomLottie,
  ...payload
}: any) => {
  let isError = false;
  const { globalState, configuration } = store.getState() || {};
  const { payloadData: globalPayloadData } = globalState || {};
  const { normalisedConfig } = configuration || {};
  const { required_fields } = payload || {};

  const requiredFieldsWidgets = required_fields?.map((fieldId: string) => {
    return normalisedConfig?.[fieldId];
  });

  const updatedNormalisedConfig = JSON.parse(JSON.stringify(normalisedConfig));
  requiredFieldsWidgets?.forEach((fieldToBeValidated: any) => {
    const { id, props } = fieldToBeValidated || {};
    const { payloadData, validate, is_visible } = props || {};
    const { regex, requiredErrorMessage, inValidErrorMessage } = validate || {};
    const { name } = payloadData || {};
    const isKeyPresent = Object.hasOwn(globalPayloadData, name);
    const fieldValue = globalPayloadData?.[name];
    const data = updatedNormalisedConfig[id];
    if (
      (!isKeyPresent || fieldValue === "" || fieldValue === null) &&
      is_visible
    ) {
      isError = true;
      data.props.error_message = requiredErrorMessage;
      scrollIntoViewWrapper(name);
      store.dispatch(
        setFieldErrorData({
          message: requiredErrorMessage,
          componentName: name,
          show: true
        })
      );
    } else if (
      isKeyPresent &&
      regex &&
      !new RegExp(regex, "i").test(globalPayloadData[name])
    ) {
      isError = true;
      scrollIntoViewWrapper(name);
      store.dispatch(
        setFieldErrorData({
          message: inValidErrorMessage,
          componentName: name,
          show: true
        })
      );
      return inValidErrorMessage;
    }
  });
  store.dispatch(
    updateNormalisedConfig({
      normalisedConfig: updatedNormalisedConfig
    })
  );
  if (!isError && !onlyValidate) {
    fetchConfigAndRedirect({
      ...payload,
      shouldRedirect,
      showBasicLoader,
      showLottie,
      showCustomBasicLoader,
      showCustomLottie,
      lottieAnimationKey: lottieAnimationKey ?? "LOADER_ANIMATION"
    });
  }
  if (onlyValidate) {
    return isError;
  }
};

export const validateAndCheckException = async ({ args }) => {
  const isError = await validateAndFetchConfigAndRedirect({
    ...args,
    onlyValidate: true
  });

  const state = store.getState();
  const fieldErrorData = state.globalState?.fieldErrorData;
  // Block modal for any error on the input field
  const hasAnyError = fieldErrorData?.message && fieldErrorData?.show;

  return !isError && !hasAnyError;
};

export const removeError = (id) => {
  const { configuration } = store.getState() || {};
  const { normalisedConfig } = configuration || {};
  let updatedNormalisedConfig = JSON.parse(JSON.stringify(normalisedConfig));
  let nodeToResetError: any = updatedNormalisedConfig[id];
  delete nodeToResetError.props.error_message;
  updatedNormalisedConfig = { ...updatedNormalisedConfig, nodeToResetError };
  store.dispatch(
    updateNormalisedConfig({
      normalisedConfig: updatedNormalisedConfig
    })
  );
};
